/**
 * Helper to pull value from stored session cookies
 * @param cookieIdentifier The identifier of the cookie.
 * @returns a string of the cookie value, or null if invalid identifier.
 */
export const getCookieValue = (cookieIdentifier: string): string | null => {
	if (!document.cookie) return null

	const cookie = document.cookie.split(";").map(c => {
		const split = c.split("=")
		return {
			key: split[0].trim(),
			value: split[1]
		}
	}).find(c => c.key === cookieIdentifier)
	return cookie ? decodeURIComponent(cookie.value) : null
}
